import React from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";

const Footer = () => {
  return (
    <div className="py-12 border-t border-border bg-background text-text">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">

        <div className="text-sm text-secondary font-medium">
          © {new Date().getFullYear()} Billie Zhang - built with love
        </div>

        <div className="flex gap-6">
          <a
            href="https://github.com/billie-zhang"
            target="_blank"
            rel="noopener noreferrer"
            className="text-secondary hover:text-text transition-colors text-xl"
            aria-label="Github"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/billiezhang/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-secondary hover:text-text transition-colors text-xl"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="mailto:billie.zhang@uwaterloo.ca"
            className="text-secondary hover:text-text transition-colors text-xl"
            aria-label="Email"
          >
            <HiOutlineMail />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;